import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  get className () {
    return this.element.dataset.classname
  }

  connect () {
    this.handleOutsideClick = this.closeOnOutsideClick.bind(this)
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnect () {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggle (event) {
    event.stopPropagation()
    this.closeOtherTooltips()
    if (this.element.classList.contains(`${this.className}::accordion-close`)) {
      this.open()
    } else {
      this.close()
    }
  }

  open () {
    this.element.classList.remove(`${this.className}::accordion-close`)
    this.element.classList.add(`${this.className}::accordion-open`)
  }

  close () {
    this.element.classList.remove(`${this.className}::accordion-open`)
    this.element.classList.add(`${this.className}::accordion-close`)
  }

  closeOnOutsideClick (event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  // annotation と note は同一controllerなので、片方を開くと他方も含めて他のツールチップを全て閉じる
  closeOtherTooltips () {
    const openClass = `${this.className}::accordion-open`
    const closedClass = `${this.className}::accordion-close`
    document.querySelectorAll(`.${CSS.escape(openClass)}`).forEach(el => {
      if (el !== this.element) {
        el.classList.remove(openClass)
        el.classList.add(closedClass)
      }
    })
  }
}
